"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEzbuy = exports.isPC = exports.isiOS = exports.isAndroid = exports.isLTOuku = exports.isLTMini = exports.isLT = exports.isTWC = exports.isPK = exports.isTH = exports.isID = exports.isMY = exports.isSG = exports.LITBSITENAME = void 0;
var isomorphismConstant_1 = require("utils/isomorphismConstant");
var country_1 = require("utils/country");
var ssrcontext_1 = require("../ssrcontext");
var LITBSITENAME;
(function (LITBSITENAME) {
    LITBSITENAME["LITBMINI"] = "LITBMINI";
    LITBSITENAME["LITBADOR"] = "LITBADOR";
    LITBSITENAME["LITBOUKUU"] = "LITBOUKU";
})(LITBSITENAME = exports.LITBSITENAME || (exports.LITBSITENAME = {}));
exports.isSG = function (country) {
    if (country === void 0) { country = isomorphismConstant_1.default.countryCode; }
    return country.toUpperCase() === "SG";
};
exports.isMY = function (country) {
    if (country === void 0) { country = isomorphismConstant_1.default.countryCode; }
    return country.toUpperCase() === "MY";
};
exports.isID = function (country) {
    if (country === void 0) { country = isomorphismConstant_1.default.countryCode; }
    return country.toUpperCase() === "ID";
};
exports.isTH = function (country) {
    if (country === void 0) { country = isomorphismConstant_1.default.countryCode; }
    return country.toUpperCase() === "TH";
};
exports.isPK = function (country) {
    if (country === void 0) { country = isomorphismConstant_1.default.countryCode; }
    return country.toUpperCase() === "PK";
};
exports.isTWC = function (country) {
    if (country === void 0) { country = isomorphismConstant_1.default.countryCode; }
    return country.toUpperCase() === "TWC";
};
exports.isLT = function (country) {
    if (country === void 0) { country = isomorphismConstant_1.default.countryCode; }
    return /litb/gi.test(country);
};
exports.isLTMini = function (country) {
    if (country === void 0) { country = isomorphismConstant_1.default.countryCode; }
    return country.toUpperCase() === LITBSITENAME.LITBMINI;
};
exports.isLTOuku = function (country) {
    if (country === void 0) { country = isomorphismConstant_1.default.countryCode; }
    return country.toUpperCase() === LITBSITENAME.LITBOUKUU;
};
exports.isAndroid = function () {
    var ua = ssrcontext_1.getUserAgent();
    return ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
};
exports.isiOS = function () {
    var ua = ssrcontext_1.getUserAgent();
    return !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
};
exports.isPC = function () {
    var ua = ssrcontext_1.getUserAgent();
    if (!ua) {
        return false;
    }
    var isMobile = /^m([0-9]|-\w+|)\./g.test(ssrcontext_1.getHostname()) ||
        ua.match(/iPhone|iPod|iPad|ios|Android|Windows Phone|SymbianOS/i);
    return !isMobile;
};
exports.isEzbuy = function (country) {
    if (country === void 0) { country = isomorphismConstant_1.default.countryCode; }
    return __spreadArrays(country_1.ezCountries).indexOf(country.toUpperCase()) > -1;
};
